enum CalculatedStudentAssignmentStatus {
  Overdue = 'OVERDUE',
  DueToday = 'DUE_TODAY',
  InProgress = 'IN_PROGRESS',
  NeedsGrading = 'NEEDS_GRADING',
}

export default CalculatedStudentAssignmentStatus;
